import cn from 'clsx'

// Components
import { IconCredits } from '@tracklib/kit'

// Types
import { Invite } from 'types'

// Utils
import { subscriptionLaunchDate } from '@constants'
import formatDate from 'lib/formatdate'

import styles from './inviteslist.css'

const statusCodeToText = (status: string, created: string): string => {
  switch (status) {
    case 'BONUS_ACTIVATED': {
      if (new Date(created) >= new Date(subscriptionLaunchDate)) {
        return 'Earned 10 credits!'
      } else {
        return 'Earned 1 credit!'
      }
    }
    case 'INVITE_ACCEPTED':
      return 'Waiting for subscription'
    case 'INVITE_SENT':
    default:
      return 'Waiting for signup'
  }
}

const getStatusPriority = (status: string): number => {
  switch (status) {
    case 'BONUS_ACTIVATED':
      return 2
    case 'INVITE_ACCEPTED':
      return 1
    case 'INVITE_SENT':
    default:
      return 0
  }
}

type InvitesListProps = {
  invites: Array<Invite>
}

const InvitesList = ({ invites }: InvitesListProps): JSX.Element => (
  <div className={styles.invitesWrapper}>
    <div>
      <div className={styles.ulHead}>
        <p>Invited</p>
        <p>Email</p>
        <p>Status</p>
      </div>
      <ul>
        {invites
          .sort((invA, invB) => new Date(invB.created).getTime() - new Date(invA.created).getTime())
          .sort((invA, invB) => getStatusPriority(invB.status) - getStatusPriority(invA.status))
          .map(invite => {
            const bonusActivated = invite.status === 'BONUS_ACTIVATED'
            const emailAddress = invite.email ? invite.email.split('@')[0] : ''
            return (
              <li key={invite.id} datatesting={`li_invited_user_${emailAddress}`}>
                <p>{formatDate(invite.created)}</p>
                <p>{invite.email}</p>
                <p className={styles.status}>
                  {bonusActivated && <IconCredits className={styles.credit} />}
                  <span className={cn(bonusActivated && styles.bonusActivatedStatus)}>
                    {statusCodeToText(invite.status, invite.created)}
                  </span>
                </p>
              </li>
            )
          })}
      </ul>
    </div>
  </div>
)

export default InvitesList
